(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("axios"), require("Vuex"), require("_"), require("Vue"));
	else if(typeof define === 'function' && define.amd)
		define(["axios", "Vuex", "_", "Vue"], factory);
	else if(typeof exports === 'object')
		exports["layout-fullscreen-qiankun"] = factory(require("axios"), require("Vuex"), require("_"), require("Vue"));
	else
		root["layout-fullscreen-qiankun"] = factory(root["axios"], root["Vuex"], root["_"], root["Vue"]);
})((typeof self !== 'undefined' ? self : this), function(__WEBPACK_EXTERNAL_MODULE_cebe__, __WEBPACK_EXTERNAL_MODULE__5880__, __WEBPACK_EXTERNAL_MODULE__60bb__, __WEBPACK_EXTERNAL_MODULE__8bbf__) {
return 